import firebase from 'firebase/app';
import 'firebase/functions';

export class UploadUtils {
  public static uploadImageToFirebaseFromUrl(url: string): Promise<string> {
    // return axios.get(url, { responseType: 'blob' }).then(function(response) {
    //   return UploadUtils.uploadImageToFirebase(response.data, 'xxxx');
    // });

    const uploadImageFromUrl = firebase.functions().httpsCallable('uploadImageFromUrl');
    return uploadImageFromUrl({url}).then((result) => {
      return result.data.url;
    });
  }

  public static uploadImageToFirebaseFromFile(file: File): Promise<string> {
    return UploadUtils.uploadImageToFirebase(file, file.name);
  }

  public static uploadImageToFirebase(content: File | Blob, filename: string): Promise<string> {
    return firebase
      .storage()
      .ref('images/' + Math.random().toString() + filename)
      .put(content)
      .then((response) => {
        return response.ref.getDownloadURL().then((downloadURL) => {
          return downloadURL;
        });
      })
      .catch((err) => console.error(err));
  }

  public static isUploadedImage(url: string) {
    return url.indexOf('firebasestorage') > -1;
  }
}